import { HttpService } from "@/core";
import {
  DictValReq,
  DictValPageReq,
  DictValPageResp,
  DictValListReq,
  DictValListResp,
  DictValDetailResp,
} from "./dict-val.interface";

export class DictValService {
  static usePageApi() {
    const api = (params: DictValPageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/tenant_dict_val/page",
        params,
      });
    return HttpService.usePagination<DictValPageResp>(api);
  }

  // static useListApi() {
  //   const api = (params: DictValListReq) =>
  //     HttpService.axios({
  //       method: "GET",
  //       url: "/tenant_dict_val/list",
  //       params,
  //     });
  //   return HttpService.useRequest<DictValListResp>(api);
  // }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/tenant_dict_val/${id}`,
      });
    return HttpService.useRequest<DictValDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: DictValReq) =>
      HttpService.axios({
        method: "POST",
        url: "/tenant_dict_val",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: DictValReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/tenant_dict_val/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/tenant_dict_val/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }
}
